import type { ThemeTypography } from '@/types';

export const FALLBACK_FONT_FAMILY = 'Poppins';

export const GOOGLE_HEADING_WEIGHTS = '400;500;600;700;800';
export const GOOGLE_BODY_WEIGHTS = '100;200;300;400;500';
export const GOOGLE_MERGED_WEIGHTS = '100;200;300;400;500;600;700;800';

export const GOOGLE_FONTS_API_HOST = 'fonts.googleapis.com';
export const GOOGLE_FONTS_DISPLAY = 'swap';

export const GOOGLE_FONTS_PRECONNECT_ORIGIN = 'https://fonts.googleapis.com';
export const GOOGLE_FONTS_GSTATIC_ORIGIN = 'https://fonts.gstatic.com';
export const TYPEKIT_PRECONNECT_ORIGIN = 'https://use.typekit.net';
export const BUNNY_FONTS_PRECONNECT_ORIGIN = 'https://fonts.bunny.net';

/** Maps stylesheet host substrings to preconnect origins. */
export const FONT_PRECONNECT_RULES = [
  { hostIncludes: 'googleapis', origin: GOOGLE_FONTS_PRECONNECT_ORIGIN },
  { hostIncludes: 'typekit', origin: TYPEKIT_PRECONNECT_ORIGIN },
  { hostIncludes: 'adobe', origin: TYPEKIT_PRECONNECT_ORIGIN },
  { hostIncludes: 'bunny', origin: BUNNY_FONTS_PRECONNECT_ORIGIN },
] as const;

export const SYSTEM_FONTS = [
  'serif',
  'sans-serif',
  'monospace',
  'cursive',
  'fantasy',
  'system-ui',
  'ui-serif',
  'ui-sans-serif',
  'ui-monospace',
] as const;

export const SYSTEM_FONT_SET = new Set<string>(SYSTEM_FONTS);

export const RAW_FILE_EXTENSIONS = ['woff2', 'woff', 'ttf', 'otf'] as const;

export const RAW_FILE_EXTENSION_SET = new Set<string>(RAW_FILE_EXTENSIONS);

export const BLOCKED_HOSTNAMES = ['localhost', '127.0.0.1', '0.0.0.0'] as const;

export const BLOCKED_HOSTNAME_SET = new Set<string>(BLOCKED_HOSTNAMES);

export const FONT_FORMAT_BY_EXT: Record<string, string> = {
  woff2: 'woff2',
  woff: 'woff',
  ttf: 'truetype',
  otf: 'opentype',
};

export const DEFAULT_RAW_FONT_FORMAT = 'woff2';

export const MAX_FONT_FAMILY_NAME_LENGTH = 80;

/** Unique href for React 19 hoisted inline styles in Fonts. */
export const THEME_RAW_FACES_STYLE_ID = 'theme-raw-font-faces';
export const THEME_TYPOGRAPHY_STYLE_ID = 'theme-typography-variables';

export const EMPTY_THEME_TYPOGRAPHY: ThemeTypography = {
  heading: { name: null, url: null },
  body: { name: null, url: null },
};

/** Matches SCSS `$breakpoints.lg` — desktop max-width values apply from this width up. */
export const DESKTOP_MIN_WIDTH = 1024;
